import wixWindow from 'wix-window';
import wixLocation from 'wix-location';
import wixUsers from 'wix-users';

import { biLoggerFactory } from 'wix-private';
const biLogger = biLoggerFactory('lp', 19, { msid: '8c2ec8ad-ae1d-49ce-89ce-1bc3448657b4' });
const biLoggerPageView = biLoggerFactory('pblc', 19, { msid: '8c2ec8ad-ae1d-49ce-89ce-1bc3448657b4' });

$w.onReady(function () {

    // $w('#box76')

    let formFactor = wixWindow.formFactor;
   
    if (formFactor == 'Mobile') {
        pageEventsMobile()
    } else {
        pageEventsDesktop()
    }

    // Write your JavaScript here
    // To select an element by ID use: $w("#elementID")

    // Click "Preview" to run your code

    $w('#button15').onClick(async () => {
        await fireEvent('Create Your Store', 'Main Page')
        wixLocation.to('https://users.wix.com/signin?postLogin=https:%2F%2Fwww.wix.com%2Fmy-account&postSignUp=http:%2F%2Fwww.wix.com%2Fnew%2Faccount&view=login&sendEmail=true')
    })

    $w('#box76').onClick(async () => {
        await fireEvent('Start Here Facebook Ads', 'Facebook Ads Inner')
        // wixLocation.to('https://www.wix.com/features/facebook-ads')
    })

    $w('#box77').onClick(async () => {
        await fireEvent('Explore Now Channels', 'Sales Channels Inner')
        // wixLocation.to('https://www.wix.com/ecommerce/sell')
    })

    $w('#box78').onClick(async () => {
        await fireEvent('Discover Wix POS', 'POS Inner')
        // wixLocation.to('https://www.wix.com/pos')
    })
    $w('#box79').onClick(async () => {
        await fireEvent('Learn How Loyalty', 'Brand Loyalty Inner')
        // wixLocation.to('https://www.wix.com/blog/ecommerce/2020/07/repeat-customers')
    })

    $w('#box80').onClick(async () => {
        await fireEvent('Learn More Subscriptions', 'Subscriptions Inner')
        // wixLocation.to('https://www.wix.com/ecommerce/sell/subscription-boxes')
    })

    $w('#box81').onClick(async () => {
        await fireEvent('Find Out How Global', 'Global Inner')
        // wixLocation.to('https://www.wix.com/blog/ecommerce/2021/01/international-ecommerce')
    })

    //talk to them to create custom form slide 2 or 3
    // $w('#button15').onClick(async () => {
    // 	await fireEvent('Subscribe', 'Main Page')
    // 	// wixLocation.to('https://users.wix.com/signin?postLogin=https:%2F%2Fwww.wix.com%2Fmy-account&postSignUp=http:%2F%2Fwww.wix.com%2Fnew%2Faccount&view=login&sendEmail=true')
    // })

});

export async function pageEventsDesktop() {
    //desktop left to right animation
     await fireEventPageView()
    $w('#OneRight').onClick(() => {
        fireEvent('Facebook Ads Fold', 'Main Page')
        $w('#OneStrip').expand()
        $w('#openStrip').collapse()
        $w('#TwoStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OneLeft').collapse()
        $w('#OpenLeft').expand()
        $w('#TwoLeft').collapse()
        $w('#ThreeLeft').collapse()
        $w('#FourLeft').collapse()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').expand()
        $w('#ThreeRight').expand()
        $w('#FourRight').expand()
        $w('#FiveRight').expand()
        $w('#SixRight').expand()
    })

        $w('#Arrow1').onClick(() => {
        fireEvent('Sales Channels Fold', 'Main Page')
        $w('#TwoStrip').expand()
        $w('#openStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OpenLeft').expand()
        $w('#OneLeft').expand()
        $w('#TwoLeft').collapse()
        $w('#ThreeLeft').collapse()
        $w('#FourLeft').collapse()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').collapse()
        $w('#ThreeRight').expand()
        $w('#FourRight').expand()
        $w('#FiveRight').expand()
        $w('#SixRight').expand()
    })

    $w('#TwoRight').onClick(() => {
        fireEvent('Sales Channels Fold', 'Main Page')
        $w('#TwoStrip').expand()
        $w('#openStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OpenLeft').expand()
        $w('#OneLeft').expand()
        $w('#TwoLeft').collapse()
        $w('#ThreeLeft').collapse()
        $w('#FourLeft').collapse()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').collapse()
        $w('#ThreeRight').expand()
        $w('#FourRight').expand()
        $w('#FiveRight').expand()
        $w('#SixRight').expand()
    })

        $w('#Arrow2').onClick(() => {
        fireEvent('POS Fold', 'Main Page')
        $w('#TwoStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#ThreeStrip').expand()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OpenLeft').expand()
        $w('#OneLeft').expand()
        $w('#TwoLeft').expand()
        $w('#ThreeLeft').collapse()
        $w('#FourLeft').collapse()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').collapse()
        $w('#ThreeRight').collapse()
        $w('#FourRight').expand()
        $w('#FiveRight').expand()
        $w('#SixRight').expand()
    })

    $w('#ThreeRight').onClick(() => {
        fireEvent('POS Fold', 'Main Page')
        $w('#TwoStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#ThreeStrip').expand()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OpenLeft').expand()
        $w('#OneLeft').expand()
        $w('#TwoLeft').expand()
        $w('#ThreeLeft').collapse()
        $w('#FourLeft').collapse()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').collapse()
        $w('#ThreeRight').collapse()
        $w('#FourRight').expand()
        $w('#FiveRight').expand()
        $w('#SixRight').expand()
    })

        $w('#Arrow3').onClick(() => {
        fireEvent('Brand Loyalty Fold', 'Main Page')
        $w('#TwoStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').expand()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OpenLeft').expand()
        $w('#OneLeft').expand()
        $w('#TwoLeft').expand()
        $w('#ThreeLeft').expand()
        $w('#FourLeft').collapse()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').collapse()
        $w('#ThreeRight').collapse()
        $w('#FourRight').collapse()
        $w('#FiveRight').expand()
        $w('#SixRight').expand()
    })

    $w('#FourRight').onClick(() => {
        fireEvent('Brand Loyalty Fold', 'Main Page')
        $w('#TwoStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').expand()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OpenLeft').expand()
        $w('#OneLeft').expand()
        $w('#TwoLeft').expand()
        $w('#ThreeLeft').expand()
        $w('#FourLeft').collapse()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').collapse()
        $w('#ThreeRight').collapse()
        $w('#FourRight').collapse()
        $w('#FiveRight').expand()
        $w('#SixRight').expand()
    })

        $w('#Arrow4').onClick(() => {
        fireEvent('Subscriptions Fold', 'Main Page')
        $w('#TwoStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').expand()
        $w('#SixStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OpenLeft').expand()
        $w('#OneLeft').expand()
        $w('#TwoLeft').expand()
        $w('#ThreeLeft').expand()
        $w('#FourLeft').expand()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').collapse()
        $w('#ThreeRight').collapse()
        $w('#FourRight').collapse()
        $w('#FiveRight').collapse()
        $w('#SixRight').expand()
    })

    $w('#FiveRight').onClick(() => {
        fireEvent('Subscriptions Fold', 'Main Page')
        $w('#TwoStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').expand()
        $w('#SixStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OpenLeft').expand()
        $w('#OneLeft').expand()
        $w('#TwoLeft').expand()
        $w('#ThreeLeft').expand()
        $w('#FourLeft').expand()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').collapse()
        $w('#ThreeRight').collapse()
        $w('#FourRight').collapse()
        $w('#FiveRight').collapse()
        $w('#SixRight').expand()
    })

        $w('#Arrow5').onClick(() => {
        fireEvent('Global Fold', 'Main Page')
        $w('#TwoStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').expand()
        $w('#OneStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OpenLeft').expand()
        $w('#OneLeft').expand()
        $w('#TwoLeft').expand()
        $w('#ThreeLeft').expand()
        $w('#FourLeft').expand()
        $w('#FiveLeft').expand()
        $w('#TwoRight').collapse()
        $w('#ThreeRight').collapse()
        $w('#FourRight').collapse()
        $w('#FiveRight').collapse()
        $w('#SixRight').collapse()
    })

    $w('#SixRight').onClick(() => {
        fireEvent('Global Fold', 'Main Page')
        $w('#TwoStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').expand()
        $w('#OneStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OpenLeft').expand()
        $w('#OneLeft').expand()
        $w('#TwoLeft').expand()
        $w('#ThreeLeft').expand()
        $w('#FourLeft').expand()
        $w('#FiveLeft').expand()
        $w('#TwoRight').collapse()
        $w('#ThreeRight').collapse()
        $w('#FourRight').collapse()
        $w('#FiveRight').collapse()
        $w('#SixRight').collapse()
    })


    $w('#OpenLeft').onClick(() => {
        fireEvent('Start Here Main Page', 'Main Page')
        $w('#OneStrip').collapse()
        $w('#openStrip').expand()
        $w('#TwoStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').collapse()
        $w('#OneRight').expand()
        $w('#OneLeft').collapse()
        $w('#OpenLeft').expand()
        $w('#TwoLeft').collapse()
        $w('#ThreeLeft').collapse()
        $w('#FourLeft').collapse()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').expand()
        $w('#ThreeRight').expand()
        $w('#FourRight').expand()
        $w('#FiveRight').expand()
        $w('#SixRight').expand()
    })

    $w('#OneLeft').onClick(() => {
        fireEvent('Facebook Ads Fold', 'Main Page')
        $w('#OneStrip').expand()
        $w('#openStrip').collapse()
        $w('#TwoStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OneLeft').collapse()
        $w('#OpenLeft').expand()
        $w('#TwoLeft').collapse()
        $w('#ThreeLeft').collapse()
        $w('#FourLeft').collapse()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').expand()
        $w('#ThreeRight').expand()
        $w('#FourRight').expand()
        $w('#FiveRight').expand()
        $w('#SixRight').expand()
    })

    $w('#TwoLeft').onClick(() => {
        fireEvent('Sales Channels Fold', 'Main Page')
        $w('#TwoStrip').expand()
        $w('#openStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OpenLeft').expand()
        $w('#OneLeft').expand()
        $w('#TwoLeft').collapse()
        $w('#ThreeLeft').collapse()
        $w('#FourLeft').collapse()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').collapse()
        $w('#ThreeRight').expand()
        $w('#FourRight').expand()
        $w('#FiveRight').expand()
        $w('#SixRight').expand()
    })

    $w('#ThreeLeft').onClick(() => {
        fireEvent('POS Fold', 'Main Page')
        $w('#TwoStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#ThreeStrip').expand()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OpenLeft').expand()
        $w('#OneLeft').expand()
        $w('#TwoLeft').expand()
        $w('#ThreeLeft').collapse()
        $w('#FourLeft').collapse()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').collapse()
        $w('#ThreeRight').collapse()
        $w('#FourRight').expand()
        $w('#FiveRight').expand()
        $w('#SixRight').expand()
    })

    $w('#FourLeft').onClick(() => {
        fireEvent('Brand Loyalty Fold', 'Main Page')
        $w('#TwoStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').expand()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OpenLeft').expand()
        $w('#OneLeft').expand()
        $w('#TwoLeft').expand()
        $w('#ThreeLeft').expand()
        $w('#FourLeft').collapse()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').collapse()
        $w('#ThreeRight').collapse()
        $w('#FourRight').collapse()
        $w('#FiveRight').expand()
        $w('#SixRight').expand()
    })

    $w('#FiveLeft').onClick(() => {
        fireEvent('Subscriptions Fold', 'Main Page')
        $w('#TwoStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').expand()
        $w('#SixStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OpenLeft').expand()
        $w('#OneLeft').expand()
        $w('#TwoLeft').expand()
        $w('#ThreeLeft').expand()
        $w('#FourLeft').expand()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').collapse()
        $w('#ThreeRight').collapse()
        $w('#FourRight').collapse()
        $w('#FiveRight').collapse()
        $w('#SixRight').expand()
    })

    $w('#openButton').onClick(() => {
        fireEvent('Facebook Ads Fold', 'Main Page')
        $w('#OneStrip').expand()
        $w('#openStrip').collapse()
        $w('#TwoStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OneLeft').expand()
        $w('#OpenLeft').expand()
        $w('#TwoLeft').collapse()
        $w('#ThreeLeft').collapse()
        $w('#FourLeft').collapse()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').expand()
        $w('#ThreeRight').expand()
        $w('#FourRight').expand()
        $w('#FiveRight').expand()
        $w('#SixRight').expand()
    })

}

export async function pageEventsMobile() {
    //mobile up and down
     await fireEventPageView()
    $w('#OneRight').onClick(() => {
        fireEvent('Facebook Ads Fold', 'Main Page')
        $w('#OneStrip').expand()
        $w('#openStrip').collapse()
        $w('#TwoStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OneLeft').expand()
        $w('#OpenLeft').expand()
        $w('#TwoLeft').collapse()
        $w('#ThreeLeft').collapse()
        $w('#FourLeft').collapse()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').expand()
        $w('#ThreeRight').expand()
        $w('#FourRight').expand()
        $w('#FiveRight').expand()
        $w('#SixRight').expand()
        $w('#OneStripAnchor').scrollTo()
    })

    $w('#TwoRight').onClick(() => {
        fireEvent('Sales Channels Fold', 'Main Page')
        $w('#TwoStrip').expand()
        $w('#openStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OpenLeft').expand()
        $w('#OneLeft').expand()
        $w('#TwoLeft').expand()
        $w('#ThreeLeft').collapse()
        $w('#FourLeft').collapse()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').collapse()
        $w('#ThreeRight').expand()
        $w('#FourRight').expand()
        $w('#FiveRight').expand()
        $w('#SixRight').expand()
        $w('#TwoStripAnchor').scrollTo()
    })

    $w('#ThreeRight').onClick(() => {
        fireEvent('POS Fold', 'Main Page')
        $w('#TwoStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#ThreeStrip').expand()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OpenLeft').expand()
        $w('#OneLeft').expand()
        $w('#TwoLeft').expand()
        $w('#ThreeLeft').expand()
        $w('#FourLeft').collapse()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').collapse()
        $w('#ThreeRight').collapse()
        $w('#FourRight').expand()
        $w('#FiveRight').expand()
        $w('#SixRight').expand()
        $w('#ThreeStripAnchor').scrollTo()
    })

    $w('#FourRight').onClick(() => {
        fireEvent('Brand Loyalty Fold', 'Main Page')
        $w('#TwoStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').expand()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OpenLeft').expand()
        $w('#OneLeft').expand()
        $w('#TwoLeft').expand()
        $w('#ThreeLeft').expand()
        $w('#FourLeft').expand()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').collapse()
        $w('#ThreeRight').collapse()
        $w('#FourRight').collapse()
        $w('#FiveRight').expand()
        $w('#SixRight').expand()
        $w('#FourStripAnchor').scrollTo()
    })

    $w('#FiveRight').onClick(() => {
        fireEvent('Subscriptions Fold', 'Main Page')
        $w('#TwoStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').expand()
        $w('#SixStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OpenLeft').expand()
        $w('#OneLeft').expand()
        $w('#TwoLeft').expand()
        $w('#ThreeLeft').expand()
        $w('#FourLeft').expand()
        $w('#FiveLeft').expand()
        $w('#TwoRight').collapse()
        $w('#ThreeRight').collapse()
        $w('#FourRight').collapse()
        $w('#FiveRight').collapse()
        $w('#SixRight').expand()
        $w('#FiveStripAnchor').scrollTo()
    })

    $w('#SixRight').onClick(() => {
        fireEvent('Global Fold', 'Main Page')
        $w('#TwoStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').expand()
        $w('#OneStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OpenLeft').expand()
        $w('#OneLeft').expand()
        $w('#TwoLeft').expand()
        $w('#ThreeLeft').expand()
        $w('#FourLeft').expand()
        $w('#FiveLeft').expand()
        $w('#TwoRight').collapse()
        $w('#ThreeRight').collapse()
        $w('#FourRight').collapse()
        $w('#FiveRight').collapse()
        $w('#SixRight').collapse()
        $w('#SixStripAnchor').scrollTo()
    })

    $w('#OpenLeft').onClick(() => {
        fireEvent('Start Here Main Page', 'Main Page')
        $w('#OneStrip').collapse()
        $w('#openStrip').expand()
        $w('#TwoStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').collapse()
        $w('#OneRight').expand()
        $w('#OneLeft').collapse()
        $w('#OpenLeft').expand()
        $w('#TwoLeft').collapse()
        $w('#ThreeLeft').collapse()
        $w('#FourLeft').collapse()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').expand()
        $w('#ThreeRight').expand()
        $w('#FourRight').expand()
        $w('#FiveRight').expand()
        $w('#SixRight').expand()
        $w('#openStrip').scrollTo()
    })

    $w('#OneLeft').onClick(() => {
        fireEvent('Facebook Ads Fold', 'Main Page')
        $w('#OneStrip').expand()
        $w('#openStrip').collapse()
        $w('#TwoStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OneLeft').expand()
        $w('#OpenLeft').expand()
        $w('#TwoLeft').collapse()
        $w('#ThreeLeft').collapse()
        $w('#FourLeft').collapse()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').expand()
        $w('#ThreeRight').expand()
        $w('#FourRight').expand()
        $w('#FiveRight').expand()
        $w('#SixRight').expand()
        $w('#OneStripAnchor').scrollTo()
    })

    $w('#TwoLeft').onClick(() => {
        fireEvent('Sales Channels Fold', 'Main Page')
        $w('#TwoStrip').expand()
        $w('#openStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OpenLeft').expand()
        $w('#OneLeft').expand()
        $w('#TwoLeft').expand()
        $w('#ThreeLeft').collapse()
        $w('#FourLeft').collapse()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').collapse()
        $w('#ThreeRight').expand()
        $w('#FourRight').expand()
        $w('#FiveRight').expand()
        $w('#SixRight').expand()
        $w('#TwoStripAnchor').scrollTo()
    })

    $w('#ThreeLeft').onClick(() => {
        fireEvent('POS Fold', 'Main Page')
        $w('#TwoStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#ThreeStrip').expand()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OpenLeft').expand()
        $w('#OneLeft').expand()
        $w('#TwoLeft').expand()
        $w('#ThreeLeft').expand()
        $w('#FourLeft').collapse()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').collapse()
        $w('#ThreeRight').collapse()
        $w('#FourRight').expand()
        $w('#FiveRight').expand()
        $w('#SixRight').expand()
        $w('#ThreeStripAnchor').scrollTo()
    })

    $w('#FourLeft').onClick(() => {
        fireEvent('Brand Loyalty Fold', 'Main Page')
        $w('#TwoStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').expand()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OpenLeft').expand()
        $w('#OneLeft').expand()
        $w('#TwoLeft').expand()
        $w('#ThreeLeft').expand()
        $w('#FourLeft').expand()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').collapse()
        $w('#ThreeRight').collapse()
        $w('#FourRight').collapse()
        $w('#FiveRight').expand()
        $w('#SixRight').expand()
        $w('#FourStripAnchor').scrollTo()
    })

    $w('#FiveLeft').onClick(() => {
        fireEvent('Subscriptions Fold', 'Main Page')
        $w('#TwoStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').expand()
        $w('#SixStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OpenLeft').expand()
        $w('#OneLeft').expand()
        $w('#TwoLeft').expand()
        $w('#ThreeLeft').expand()
        $w('#FourLeft').expand()
        $w('#FiveLeft').expand()
        $w('#TwoRight').collapse()
        $w('#ThreeRight').collapse()
        $w('#FourRight').collapse()
        $w('#FiveRight').collapse()
        $w('#SixRight').expand()
        $w('#FiveStripAnchor').scrollTo()
    })

    $w('#openButton').onClick(() => {
        fireEvent('Facebook Ads Fold', 'Main Page')
        $w('#OneStrip').expand()
        $w('#openStrip').collapse()
        $w('#TwoStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OneLeft').expand()
        $w('#OpenLeft').expand()
        $w('#TwoLeft').collapse()
        $w('#ThreeLeft').collapse()
        $w('#FourLeft').collapse()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').expand()
        $w('#ThreeRight').expand()
        $w('#FourRight').expand()
        $w('#FiveRight').expand()
        $w('#SixRight').expand()
        $w('#OneStripAnchor').scrollTo()
    })

        $w('#Arrow1').onClick(() => {
        fireEvent('Sales Channels Fold', 'Main Page')
        $w('#TwoStrip').expand()
        $w('#openStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OpenLeft').expand()
        $w('#OneLeft').expand()
        $w('#TwoLeft').collapse()
        $w('#ThreeLeft').collapse()
        $w('#FourLeft').collapse()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').collapse()
        $w('#ThreeRight').expand()
        $w('#FourRight').expand()
        $w('#FiveRight').expand()
        $w('#SixRight').expand()
        $w('#TwoStripAnchor').scrollTo()
    })


        $w('#Arrow2').onClick(() => {
        fireEvent('POS Fold', 'Main Page')
        $w('#TwoStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#ThreeStrip').expand()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OpenLeft').expand()
        $w('#OneLeft').expand()
        $w('#TwoLeft').expand()
        $w('#ThreeLeft').collapse()
        $w('#FourLeft').collapse()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').collapse()
        $w('#ThreeRight').collapse()
        $w('#FourRight').expand()
        $w('#FiveRight').expand()
        $w('#SixRight').expand()
        $w('#ThreeStripAnchor').scrollTo()
    })


        $w('#Arrow3').onClick(() => {
        fireEvent('Brand Loyalty Fold', 'Main Page')
        $w('#TwoStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').expand()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OpenLeft').expand()
        $w('#OneLeft').expand()
        $w('#TwoLeft').expand()
        $w('#ThreeLeft').expand()
        $w('#FourLeft').collapse()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').collapse()
        $w('#ThreeRight').collapse()
        $w('#FourRight').collapse()
        $w('#FiveRight').expand()
        $w('#SixRight').expand()
        $w('#FourStripAnchor').scrollTo()
    })


        $w('#Arrow4').onClick(() => {
        fireEvent('Subscriptions Fold', 'Main Page')
        $w('#TwoStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').expand()
        $w('#SixStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OpenLeft').expand()
        $w('#OneLeft').expand()
        $w('#TwoLeft').expand()
        $w('#ThreeLeft').expand()
        $w('#FourLeft').expand()
        $w('#FiveLeft').collapse()
        $w('#TwoRight').collapse()
        $w('#ThreeRight').collapse()
        $w('#FourRight').collapse()
        $w('#FiveRight').collapse()
        $w('#SixRight').expand()
        $w('#FiveStripAnchor').scrollTo()
    })


        $w('#Arrow5').onClick(() => {
        fireEvent('Global Fold', 'Main Page')
        $w('#TwoStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneStrip').collapse()
        $w('#ThreeStrip').collapse()
        $w('#FourStrip').collapse()
        $w('#FiveStrip').collapse()
        $w('#SixStrip').expand()
        $w('#OneStrip').collapse()
        $w('#openStrip').collapse()
        $w('#OneRight').collapse()
        $w('#OpenLeft').expand()
        $w('#OneLeft').expand()
        $w('#TwoLeft').expand()
        $w('#ThreeLeft').expand()
        $w('#FourLeft').expand()
        $w('#FiveLeft').expand()
        $w('#TwoRight').collapse()
        $w('#ThreeRight').collapse()
        $w('#FourRight').collapse()
        $w('#FiveRight').collapse()
        $w('#SixRight').collapse()
        $w('#SixStripAnchor').scrollTo()
    })

}

export async function fireEvent(buttonName, topic) {

    let isUserLoggedIn = wixUsers.currentUser.loggedIn;
    if (isUserLoggedIn) {
        try {
            const biEventObject = {
                evid: 703,
                topic: topic,
                Button_name: buttonName,
                is_valid: true,
                page_url: wixLocation.url,
                msid: '8c2ec8ad-ae1d-49ce-89ce-1bc3448657b4',
                uuid: wixUsers.currentUser.id
            };
            await biLogger.log(biEventObject);

        } catch (err) {
            console.log(err, "sth went wrong")
        }
    } else {
        try {
            const biEventObject = {
                evid: 703,
                topic: topic,
                Button_name: buttonName,
                is_valid: true,
                msid: '8c2ec8ad-ae1d-49ce-89ce-1bc3448657b4',
                url: wixLocation.url,
                page_url: wixLocation.url
                
            };
            await biLogger.log(biEventObject);
        } catch (err) {
            console.log(err, "sth went wrong")
        }
    }

}

export async function fireEventPageView() {

    try {
        const biEventObject = {
            evid: 1001,
            http_referrer: wixLocation.baseUrl,
            referral: wixWindow.referrer,
            msid: '8c2ec8ad-ae1d-49ce-89ce-1bc3448657b4',
            // uuid: wixUsers.currentUser.id
        };
        // await biLogger.log(biEventObject);
        await biLoggerPageView.log(biEventObject)

    } catch (err) {
        console.log(err, "sth went wrong")
    }

    try {
        const biEventObject = {
            evid: 1000,
            // http_referrer: wixLocation.baseUrl,
            referral: wixWindow.referrer,
            msid: '8c2ec8ad-ae1d-49ce-89ce-1bc3448657b4',
            uuid: wixUsers.currentUser.id
        };
        // await biLogger.log(biEventObject);
        await biLoggerPageView.log(biEventObject)

    } catch (err) {
        console.log(err, "sth went wrong")
    }

}

// export function openButton_click(event) {
//     fireEvent('Start Here Main Page', 'Main Page')
//     $w('#OneStrip').expand()
//     $w('#openStrip').collapse()
//     $w('#TwoStrip').collapse()
//     $w('#ThreeStrip').collapse()
//     $w('#FourStrip').collapse()
//     $w('#FiveStrip').collapse()
//     $w('#SixStrip').collapse()
//     $w('#OneRight').collapse()
//     $w('#OneLeft').expand()
//     $w('#OpenLeft').expand()
//     $w('#TwoLeft').collapse()
//     $w('#ThreeLeft').collapse()
//     $w('#FourLeft').collapse()
//     $w('#FiveLeft').collapse()
//     $w('#TwoRight').expand()
//     $w('#ThreeRight').expand()
//     $w('#FourRight').expand()
//     $w('#FiveRight').expand()
//     $w('#SixRight').expand()
// }

// export function OneRight_click(event) {
//     fireEvent('Facebook Ads Fold', 'Main Page')
//     $w('#OneStrip').expand()
//     $w('#openStrip').collapse()
//     $w('#TwoStrip').collapse()
//     $w('#ThreeStrip').collapse()
//     $w('#FourStrip').collapse()
//     $w('#FiveStrip').collapse()
//     $w('#SixStrip').collapse()
//     $w('#OneRight').collapse()
//     $w('#OneLeft').expand()
//     $w('#OpenLeft').expand()
//     $w('#TwoLeft').collapse()
//     $w('#ThreeLeft').collapse()
//     $w('#FourLeft').collapse()
//     $w('#FiveLeft').collapse()
//     $w('#TwoRight').expand()
//     $w('#ThreeRight').expand()
//     $w('#FourRight').expand()
//     $w('#FiveRight').expand()
//     $w('#SixRight').expand()
// }

// export function TwoRight_click(event) {
//     fireEvent('Sales Channels Fold', 'Main Page')
//     $w('#TwoStrip').expand()
//     $w('#openStrip').collapse()
//     $w('#OneStrip').collapse()
//     $w('#ThreeStrip').collapse()
//     $w('#FourStrip').collapse()
//     $w('#FiveStrip').collapse()
//     $w('#SixStrip').collapse()
//     $w('#OneStrip').collapse()
//     $w('#openStrip').collapse()
//     $w('#OneRight').collapse()
//     $w('#OpenLeft').expand()
//     $w('#OneLeft').expand()
//     $w('#TwoLeft').expand()
//     $w('#ThreeLeft').collapse()
//     $w('#FourLeft').collapse()
//     $w('#FiveLeft').collapse()
//     $w('#TwoRight').collapse()
//     $w('#ThreeRight').expand()
//     $w('#FourRight').expand()
//     $w('#FiveRight').expand()
//     $w('#SixRight').expand()
// }

// export function ThreeRight_click(event) {
//     fireEvent('POS Fold', 'Main Page')
//     $w('#TwoStrip').collapse()
//     $w('#openStrip').collapse()
//     $w('#OneStrip').collapse()
//     $w('#ThreeStrip').expand()
//     $w('#FourStrip').collapse()
//     $w('#FiveStrip').collapse()
//     $w('#SixStrip').collapse()
//     $w('#OneStrip').collapse()
//     $w('#openStrip').collapse()
//     $w('#OneRight').collapse()
//     $w('#OpenLeft').expand()
//     $w('#OneLeft').expand()
//     $w('#TwoLeft').expand()
//     $w('#ThreeLeft').expand()
//     $w('#FourLeft').collapse()
//     $w('#FiveLeft').collapse()
//     $w('#TwoRight').collapse()
//     $w('#ThreeRight').collapse()
//     $w('#FourRight').expand()
//     $w('#FiveRight').expand()
//     $w('#SixRight').expand()
// }

// export function FourRight_click(event) {
//     fireEvent('Brand Loyalty Fold', 'Main Page')
//     $w('#TwoStrip').collapse()
//     $w('#openStrip').collapse()
//     $w('#OneStrip').collapse()
//     $w('#ThreeStrip').collapse()
//     $w('#FourStrip').expand()
//     $w('#FiveStrip').collapse()
//     $w('#SixStrip').collapse()
//     $w('#OneStrip').collapse()
//     $w('#openStrip').collapse()
//     $w('#OneRight').collapse()
//     $w('#OpenLeft').expand()
//     $w('#OneLeft').expand()
//     $w('#TwoLeft').expand()
//     $w('#ThreeLeft').expand()
//     $w('#FourLeft').expand()
//     $w('#FiveLeft').collapse()
//     $w('#TwoRight').collapse()
//     $w('#ThreeRight').collapse()
//     $w('#FourRight').collapse()
//     $w('#FiveRight').expand()
//     $w('#SixRight').expand()
// }

// export function FiveRight_click(event) {
//     fireEvent('Subscriptions Fold', 'Main Page')
//     $w('#TwoStrip').collapse()
//     $w('#openStrip').collapse()
//     $w('#OneStrip').collapse()
//     $w('#ThreeStrip').collapse()
//     $w('#FourStrip').collapse()
//     $w('#FiveStrip').expand()
//     $w('#SixStrip').collapse()
//     $w('#OneStrip').collapse()
//     $w('#openStrip').collapse()
//     $w('#OneRight').collapse()
//     $w('#OpenLeft').expand()
//     $w('#OneLeft').expand()
//     $w('#TwoLeft').expand()
//     $w('#ThreeLeft').expand()
//     $w('#FourLeft').expand()
//     $w('#FiveLeft').expand()
//     $w('#TwoRight').collapse()
//     $w('#ThreeRight').collapse()
//     $w('#FourRight').collapse()
//     $w('#FiveRight').collapse()
//     $w('#SixRight').expand()
// }

// export function SixRight_click(event) {
//     fireEvent('Global Fold', 'Main Page')
//     $w('#TwoStrip').collapse()
//     $w('#openStrip').collapse()
//     $w('#OneStrip').collapse()
//     $w('#ThreeStrip').collapse()
//     $w('#FourStrip').collapse()
//     $w('#FiveStrip').collapse()
//     $w('#SixStrip').expand()
//     $w('#OneStrip').collapse()
//     $w('#openStrip').collapse()
//     $w('#OneRight').collapse()
//     $w('#OpenLeft').expand()
//     $w('#OneLeft').expand()
//     $w('#TwoLeft').expand()
//     $w('#ThreeLeft').expand()
//     $w('#FourLeft').expand()
//     $w('#FiveLeft').expand()
//     $w('#TwoRight').collapse()
//     $w('#ThreeRight').collapse()
//     $w('#FourRight').collapse()
//     $w('#FiveRight').collapse()
//     $w('#SixRight').collapse()
// }

// export function OpenLeft_click(event) {
//     $w('#openStrip').expand()
//     $w('#OneStrip').collapse()
//     $w('#TwoStrip').collapse()
//     $w('#ThreeStrip').collapse()
//     $w('#FourStrip').collapse()
//     $w('#FiveStrip').collapse()
//     $w('#SixStrip').collapse()
//     $w('#OpenLeft').collapse()
//     $w('#OneLeft').collapse()
//     $w('#TwoLeft').collapse()
//     $w('#ThreeLeft').collapse()
//     $w('#FourLeft').collapse()
//     $w('#FiveLeft').collapse()
//     $w('#OneRight').expand()
//     $w('#TwoRight').expand()
//     $w('#ThreeRight').expand()
//     $w('#FourRight').expand()
//     $w('#FiveRight').expand()
//     $w('#SixRight').expand()
// }

// export function OneLeft_click(event) {
//     $w('#openStrip').collapse()
//     $w('#OneStrip').expand()
//     $w('#TwoStrip').collapse()
//     $w('#ThreeStrip').collapse()
//     $w('#FourStrip').collapse()
//     $w('#FiveStrip').collapse()
//     $w('#SixStrip').collapse()
//     $w('#OpenLeft').expand()
//     $w('#OneLeft').expand()
//     $w('#TwoLeft').collapse()
//     $w('#ThreeLeft').collapse()
//     $w('#FourLeft').collapse()
//     $w('#FiveLeft').collapse()
//     $w('#OneRight').collapse()
//     $w('#TwoRight').expand()
//     $w('#ThreeRight').expand()
//     $w('#FourRight').expand()
//     $w('#FiveRight').expand()
//     $w('#SixRight').expand()
// }

// export function TwoLeft_click(event) {
//     $w('#openStrip').collapse()
//     $w('#OneStrip').collapse()
//     $w('#TwoStrip').expand()
//     $w('#ThreeStrip').collapse()
//     $w('#FourStrip').collapse()
//     $w('#FiveStrip').collapse()
//     $w('#SixStrip').collapse()
//     $w('#OpenLeft').expand()
//     $w('#OneLeft').expand()
//     $w('#TwoLeft').expand()
//     $w('#ThreeLeft').collapse()
//     $w('#FourLeft').collapse()
//     $w('#FiveLeft').collapse()
//     $w('#OneRight').collapse()
//     $w('#TwoRight').collapse()
//     $w('#ThreeRight').expand()
//     $w('#FourRight').expand()
//     $w('#FiveRight').expand()
//     $w('#SixRight').expand()
// }

// export function ThreeLeft_click(event) {
//     $w('#openStrip').collapse()
//     $w('#OneStrip').collapse()
//     $w('#TwoStrip').collapse()
//     $w('#ThreeStrip').expand()
//     $w('#FourStrip').collapse()
//     $w('#FiveStrip').collapse()
//     $w('#SixStrip').collapse()
//     $w('#OpenLeft').expand()
//     $w('#OneLeft').expand()
//     $w('#TwoLeft').expand()
//     $w('#ThreeLeft').expand()
//     $w('#FourLeft').collapse()
//     $w('#FiveLeft').collapse()
//     $w('#OneRight').collapse()
//     $w('#TwoRight').collapse()
//     $w('#ThreeRight').collapse()
//     $w('#FourRight').expand()
//     $w('#FiveRight').expand()
//     $w('#SixRight').expand()
// }

// export function FourLeft_click(event) {
//     $w('#openStrip').collapse()
//     $w('#OneStrip').collapse()
//     $w('#TwoStrip').collapse()
//     $w('#ThreeStrip').collapse()
//     $w('#FourStrip').expand()
//     $w('#FiveStrip').collapse()
//     $w('#SixStrip').collapse()
//     $w('#OpenLeft').expand()
//     $w('#OneLeft').expand()
//     $w('#TwoLeft').expand()
//     $w('#ThreeLeft').expand()
//     $w('#FourLeft').expand()
//     $w('#FiveLeft').collapse()
//     $w('#OneRight').collapse()
//     $w('#TwoRight').collapse()
//     $w('#ThreeRight').collapse()
//     $w('#FourRight').collapse()
//     $w('#FiveRight').expand()
//     $w('#SixRight').expand()
// }

// export function FiveLeft_click(event) {
//     $w('#openStrip').collapse()
//     $w('#OneStrip').collapse()
//     $w('#TwoStrip').collapse()
//     $w('#ThreeStrip').collapse()
//     $w('#FourStrip').collapse()
//     $w('#FiveStrip').expand()
//     $w('#SixStrip').collapse()
//     $w('#OpenLeft').expand()
//     $w('#OneLeft').expand()
//     $w('#TwoLeft').expand()
//     $w('#ThreeLeft').expand()
//     $w('#FourLeft').expand()
//     $w('#FiveLeft').expand()
//     $w('#OneRight').collapse()
//     $w('#TwoRight').collapse()
//     $w('#ThreeRight').collapse()
//     $w('#FourRight').collapse()
//     $w('#FiveRight').collapse()
//     $w('#SixRight').expand()
// }

// export function SixLeft_click(event) {
//     $w('#openStrip').collapse()
//     $w('#OneStrip').collapse()
//     $w('#TwoStrip').collapse()
//     $w('#ThreeStrip').collapse()
//     $w('#FourStrip').collapse()
//     $w('#FiveStrip').collapse()
//     $w('#SixStrip').expand()
//     $w('#OpenLeft').expand()
//     $w('#OneLeft').expand()
//     $w('#TwoLeft').expand()
//     $w('#ThreeLeft').expand()
//     $w('#FourLeft').expand()
//     $w('#FiveLeft').expand()
//     $w('#OneRight').collapse()
//     $w('#TwoRight').collapse()
//     $w('#ThreeRight').collapse()
//     $w('#FourRight').collapse()
//     $w('#FiveRight').collapse()
//     $w('#SixRight').collapse()
// }